"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Chart = /** @class */ (function (_super) {
    __extends(Chart, _super);
    function Chart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Chart.prototype.render = function () {
        var _a = this.props, width = _a.width, height = _a.height, padding = _a.padding, onMouseOut = _a.onMouseOut, onMouseOver = _a.onMouseOver, onMouseMove = _a.onMouseMove, onClick = _a.onClick, children = _a.children;
        var innerWidth = width, innerHeight = height;
        if (innerWidth - padding >= 0) {
            innerWidth = innerWidth - padding;
        }
        if (innerHeight - padding >= 0) {
            innerHeight = innerHeight - padding;
        }
        return (React.createElement("svg", { width: width, height: height, onMouseLeave: onMouseOut, onMouseEnter: onMouseOver, onMouseMove: onMouseMove, onClick: onClick },
            React.createElement("svg", { width: innerWidth, height: innerHeight, x: padding / 2, y: -padding / 2, style: { overflow: 'visible' } }, children)));
    };
    return Chart;
}(React.Component));
exports.default = Chart;
//# sourceMappingURL=Chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/LineChart/Chart.js
// module id = 138
// module chunks = 0